import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Recipe from '../components/recipe/';

type Props = {
  pageContext: {
    recipe: Recipe;
  };
};

const TemplateRecipe = ({ pageContext }: Props) => {
  const { recipe } = pageContext;

  return (
    <Layout>
      <SEO
        bodyClass={`recipe bg-${recipe.rid}`}
        description={recipe.meta.description}
        facebook={recipe.meta.facebook}
        slug={`/${recipe.slug}`}
        twitter={recipe.meta.twitter}
        title={recipe.title}
      />
      <Recipe recipe={recipe} />
    </Layout>
  );
};

export default TemplateRecipe;
